window.store = new Vue({
    data() {
        return {
            state: {},
        }
    },

    methods: {
        set(item, value) {
            this.state[item] = value;
        },
    },
});
